import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import PropTypes from 'prop-types'
import { modal } from 'helpers/decorators'
import { FileCard, Title } from 'components/misc'
import { apiDownloadFile } from 'helpers/decorators/api'

const DownloadableFileCard = apiDownloadFile()(FileCard)

@injectIntl
@modal.trigger()
class ObservationOverview extends Component {
  static propTypes = {
    readOnly: PropTypes.bool,
    colorClass: PropTypes.string,
    fileUrls: PropTypes.array,
    observations: PropTypes.string,
    intl: PropTypes.func,
    header: PropTypes.any
  }

  render() {
    const {
      colorClass,
      fileUrls,
      observations,
      intl,
      header,
      readOnly
    } = this.props

    return (
      <div>
        {header}

        <div
          style={
            !readOnly
              ? {
                  paddingTop: 5,
                  marginTop: 20,
                  borderTop: '1px solid #eee'
                }
              : {}
          }
        >
          <Title
            h5
            colorClass={colorClass}
            intlKey="label.journey_observations"
          >
            Journey Observations
          </Title>
        </div>

        <blockquote>{observations}</blockquote>

        {fileUrls &&
          fileUrls.length > 0 && (
            <div>
              <div
                style={{
                  margin: '25px 0 15px'
                }}
              >
                <Title colorClass={colorClass} intlKey="tabs.files" h5>
                  Attached files
                </Title>
              </div>

              <div className="row">
                {fileUrls.map((url, index) => (
                  <div key={url} className="col-xs-12 col-md-6">
                    <DownloadableFileCard
                      files={fileUrls}
                      src={url}
                      file={{
                        title: `${intl.formatMessage({
                          id: 'label.attached_file',
                          defaultMessage: 'Attached file'
                        })} ${++index}`
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
      </div>
    )
  }
}

export default ObservationOverview
